import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { CirclePrimitive } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var Circle = function Circle(_ref) {
  var color = _ref.color;
  var theme = useTheme();
  var ringColor = color || theme.colorPalette.primaryColors.main.shade_default;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CirclePrimitive, {
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 30,
    delay: -1.1,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 60,
    delay: -1,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 90,
    delay: -0.9,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 120,
    delay: -0.8,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 150,
    delay: -0.7,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 180,
    delay: -0.6,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 210,
    delay: -0.5,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 240,
    delay: -0.4,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 270,
    delay: -0.3,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 300,
    delay: -0.2,
    color: ringColor
  }), /*#__PURE__*/React.createElement(CirclePrimitive, {
    rotate: 330,
    delay: -0.1,
    color: ringColor
  }));
};

process.env.NODE_ENV !== "production" ? Circle.propTypes = {
  color: PropTypes.string
} : void 0;
Circle.defaultProps = {
  color: undefined
};
process.env.NODE_ENV !== "production" ? Circle.displayName = 'Circle' : void 0;
var Circle$1 = Circle;

export { Circle$1 as default };
